import { request } from '../request';

const AIDiagnose = {
  /**
   * 查询用户调理信息
   */
  getCustomerHopList(params: GetCustomerHopeListParams) {
    return request<GetCustomerHopeListResponse>({
      path: '/pad/customer/hope/v1/list',
      method: 'POST',
      data: params,
    });
  },
  /**
   * 保存提交内容
   */
  submit(params: AIDiagnoseSubmitParams) {
    return request<string>({
      path: '/pad/customer/health/report/v1/submit',
      method: 'POST',
      data: params,
    });
  },
  /** 获取问诊信息 */
  getTongueResult(params: GetTongueResultParams) {
    return request<GetTongueResultResponse>({
      path: '/pad/diagnose/tongue/v1/submit',
      method: 'POST',
      query: params,
    });
  },
  /** 获取舌诊报告 */
  getTongueReport(params: GetTongueReportParams) {
    return request<number>({
      path: '/pad/diagnose/tongue/v1/report',
      method: 'POST',
      data: params,
    });
  },
  getAIDiagnoseReport(sessionId: string) {
    return request<GetAIDiagnoseResultResponse>({
      path: '/pad/customer/health/report/v1/get',
      query: { sessionId },
    });
  },
};

export default AIDiagnose;
